<div id="{{cardTitle}}-full" class="card" *ngIf="!minimal">
    <figure>
        <img src="{{cardIconUrl}}" alt="{{cardTitle}}">
    </figure>
    <div id="{{cardTitle}}-title" class="card-title">{{cardTitle}}</div>
    <p id="{{cardTitle}}-description" class="card-description">{{cardDescription}}</p>
    <div class="card-link">
        <a id="{{cardTitle}}-link" routerLink="{{cardLink}}" *ngIf="cardLink">Conheça Mais</a>
        <a id="{{cardTitle}}-link-modal" (click)="showModal(cardTitle, cardDescriptionFull)" *ngIf="!cardLink">Conheça Mais</a>
    </div>
</div>

<div id="{{cardTitle}}-compact" class="card only-icon-title" *ngIf="minimal">
    <figure>
        <img src="{{cardIconUrl}}" alt="{{cardTitle}}">
    </figure>
    <div id="{{cardTitle}}--compact-title" class="card-title">{{cardTitle}}</div>
</div>